import styled from "styled-components";
import { Box } from "@similarweb/ui-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledBox = styled(Box)<{
    height?: string;
    width?: string;
    minWidth?: string;
    maxWidth?: string;
    marginRight?: string;
}>`
    display: flex;
    flex-direction: column;
    ${({ height }) => height && `height:${height}`};
    ${({ width }) => width && `width:${width}`};
    ${({ marginRight }) => marginRight && `margin-right:${marginRight}`};
    ${({ maxWidth }) => maxWidth && `max-width:${maxWidth}`};
    ${({ minWidth }) => minWidth && `min-width:${minWidth}`};
`;

export const SectionWrapper = styled(FlexRow)`
    margin-bottom: 24px;
    align-items: center;
`;
